export enum PortalLoanPurposeType {
	Purchase = 'Purchase',
	Refinance = 'Refinance',
	RefinanceCashout = 'Refinance Cashout',
	Construct = 'Construction',
	ConstructPermanent = 'Construction Permanent',
	FHAStreamlinedRefinance = 'FHA Streamlined Refinance',
	VAIRRRL = 'VA IRRRL',
	HomeEquity = 'Home Equity',
	Other = 'Other',
	RTRefinance = 'R/T Refinance',
	Cashout = 'Cashout',
}